import { listCreditPacks } from '@/services/order.service.js';

const state = {
  creditPacks: null,
};

const actions = {

  async getCreditPacks({ commit }) {
    return listCreditPacks().then((response) => {
      console.log('listCreditPacks', response);
      commit('setCreditPacks', response.data.data);
    });
  },

};

const mutations = {

  setCreditPacks(state, data) {
    state.creditPacks = data;
  },

};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
